import { render, staticRenderFns } from "./OrderVerification.vue?vue&type=template&id=37f5b4d0&"
import script from "./OrderVerification.vue?vue&type=script&lang=js&"
export * from "./OrderVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports